<template>
  <div class="content-container">
    <PostTransactionSearch
      :recode="recode"
      :status="status"
      @onSearch="onSearch"
      @onReset="onReset"
    />
    <div class="das-layout gap-20 my-10 flex-1">
      <div class="l-w-40 column">
        <PostTransactionCustomerList
          ref="postTransactionCustomerList"
          @rowClicked="customerRowClicked"
        />
      </div>
      <div class="l-w-60 column gap-0">
        <PostTransactionCustomerInfo
          ref="postTransactionCustomerInfo"
          :booking-info="bookingInfo"
          :emited-money="emitedMoney"
          :deposit-money="depositMoney"
          :checkout-permit-from-api="checkoutPermitFromApi"
          :is-row-selected="isPostTransactionRowClicked"
        />
        <PostTransactionTransactionList
          ref="postTransactionTransactionList"
          :booking-info="bookingInfo"
          @emitedMoneyChanged="emitedMoneyChanged"
        />
      </div>
    </div>
    <BottomButtons
      :is-row-selected="isPostTransactionRowClicked"
      :booking-info="bookingInfo"
    />
  </div>
</template>
<script>
import { getUserDetailApi } from '@/api/profile/profile'
// COMPONENTS
import PostTransactionSearch from './components/postTransactionSearch.vue'
import PostTransactionCustomerList from './components/postTransactionCustomerList.vue'
import PostTransactionCustomerInfo from './components/postTransactionCustomerInfo.vue'
import PostTransactionTransactionList from './components/postTransactionTransactionList.vue'
import BottomButtons from './components/bottomButtons.vue'
export default {
  components: {
    PostTransactionSearch,
    PostTransactionCustomerList,
    PostTransactionCustomerInfo,
    PostTransactionTransactionList,
    BottomButtons
  },
  data() {
    return {
      emitedMoney: 0,
      depositMoney: 0,
      checkoutPermitFromApi: false,
      bookingInfo: {
        check_in_date: null
      },
      isPostTransactionRowClicked: false,
      recode: null,
      status: null
    }
  },
  created() {
    console.log(this.$route.query.recode, 'chehhe')
    this.recode = this.$route.query.recode
    this.status = this.$route.query.status
  },
  async mounted() {
    // const urlParams = new URLSearchParams(window.location.search)
    // console.log(urlParams.get('recode'), 'check')

    await this.getUserInfo()
    this.onSearch()
  },
  methods: {
    emitedMoneyChanged(totalMoney, depositMoney, checkoutPermitFromApi) {
      this.emitedMoney = totalMoney
      this.depositMoney = depositMoney
      this.checkoutPermitFromApi = checkoutPermitFromApi
    },
    onSearch(params) {
      this.$refs.postTransactionCustomerList.attachData(params)
    },
    onReset(params) {
      this.$refs.postTransactionCustomerList.attachData(params)
    },
    async customerRowClicked(row) {
      if (row && row.id) {
        this.isPostTransactionRowClicked = true
        this.bookingInfo = row
        await this.$refs.postTransactionTransactionList.getTranPageById(row.id)
      } else {
        this.isPostTransactionRowClicked = false
      }
    },
    async getUserInfo() {
      const user = await getUserDetailApi()
      const userData = user.data?.user || null
      if (userData) {
        this.$store.dispatch('user/addUserInfo', userData)
      }
    }
  }
}
</script>
